export default __webpack_public_path__ + "static/media/LoginPageImg.cb31d603.png";